import { render, staticRenderFns } from "./nutritionMainpage.vue?vue&type=template&id=abaaa4fa"
import script from "./nutritionMainpage.vue?vue&type=script&lang=js"
export * from "./nutritionMainpage.vue?vue&type=script&lang=js"
import style0 from "./nutritionMainpage.vue?vue&type=style&index=0&id=abaaa4fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports